var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSectionDecoration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1639,
    height: 1482,
    viewBox: "0 0 1639 1482",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1639,
    height: 1482,
    rx: 741,
    fill: "url(#paint0_linear_298_6104)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_298_6104",
    x1: 819.5,
    y1: 617,
    x2: 819.5,
    y2: 1482,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3E3E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3E3E0",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSectionDecoration);
export default __webpack_public_path__ + "static/media/section-decoration.2cd5e66f912caba18fb21666099f0733.svg";
export { ForwardRef as ReactComponent };